import { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { LeafIcon, XIcon } from 'lucide-react';
import { useCatalog } from '../../../contexts/CatalogContext';
import { useSkinPlan } from '../../../hooks/useSkinPlan';
import { seasonNote } from '../../../utils/skinTips';
import { readLocal, writeLocal } from '../../../core/storage';
import { ease } from '../../../core/format/motion';
const KEY = 'bb-season-dismissed';

/** Eén regel over het seizoen, afgestemd op haar producten. Weg te klikken tot het volgende seizoen. */
export function SeasonBanner() {
  const {
    items
  } = useSkinPlan();
  const {
    productById
  } = useCatalog();
  const reduce = useReducedMotion();
  const note = seasonNote(items, productById);
  const [dismissed, setDismissed] = useState(() => readLocal(KEY));
  const show = note && dismissed !== note.key;
  return <AnimatePresence initial={false} data-id="element-6296" data-mp="1pmdncjdit18m">
      {show && note && <motion.aside aria-label="Seizoenstip" initial={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      height: 0
    }} animate={reduce ? {
      opacity: 1
    } : {
      opacity: 1,
      height: 'auto'
    }} exit={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.22,
      ease
    }} className="overflow-hidden" data-id="element-6297" data-mp="1ughv34um1dar">
          <div className="flex items-start gap-3 bg-sage/15 px-4 py-3.5 sm:px-5" data-id="element-6298" data-mp="3plcoq2h26qsw">
            <LeafIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={1.5} aria-hidden="true" data-id="element-6299" data-mp="773ucmcpo2ka" />
            <p className="min-w-0 flex-1 text-[14px] leading-relaxed text-ink" data-id="element-6300" data-mp="2923hf91myy9">
              <span className="font-medium" data-id="element-6301" data-mp="h5jaxve43tfj">{note.title}.</span> {note.body}
            </p>
            {/* 40px raakvlak; de negatieve marge houdt de regel even hoog. */}
            <button type="button" onClick={() => {
          setDismissed(note.key);
          writeLocal(KEY, note.key);
        }} aria-label="Seizoenstip sluiten tot het volgende seizoen" className="-my-2 -mr-2.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-muted transition-colors duration-150 ease-soft hover:bg-shell hover:text-ink" data-id="element-6302" data-mp="c4n7fixoa9an">
              <XIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6303" data-mp="3cmnc5edvig4u" />
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}